const AUTH_TOKEN_KEY = 'auth_token';
const CONTROL_CHARACTERS = /[\r\n]/g;

export const normalizeAuthToken = (token) => {
  if (typeof token !== 'string') {
    return '';
  }

  return token.replace(CONTROL_CHARACTERS, '').trim();
};

const getStorage = () => {
  if (typeof localStorage === 'undefined') {
    return null;
  }

  return localStorage;
};

export const getStoredAuthToken = () => {
  const storage = getStorage();

  if (!storage) {
    return '';
  }

  try {
    return normalizeAuthToken(storage.getItem(AUTH_TOKEN_KEY));
  } catch (error) {
    return '';
  }
};

export const setStoredAuthToken = (token) => {
  const storage = getStorage();
  const normalizedToken = normalizeAuthToken(token);

  if (!storage) {
    return normalizedToken;
  }

  try {
    if (normalizedToken) {
      storage.setItem(AUTH_TOKEN_KEY, normalizedToken);
    } else {
      storage.removeItem(AUTH_TOKEN_KEY);
    }
  } catch (error) {
    return normalizedToken;
  }

  return normalizedToken;
};

export const clearStoredAuthToken = () => {
  const storage = getStorage();

  if (!storage) {
    return null;
  }

  try {
    storage.removeItem(AUTH_TOKEN_KEY);
    return null;
  } catch (error) {
    return error;
  }
};

export const applyAuthHeader = (httpClient, token) => {
  const normalizedToken = normalizeAuthToken(token);

  if (normalizedToken) {
    httpClient.defaults.headers.common.Authorization = normalizedToken;
  } else {
    delete httpClient.defaults.headers.common.Authorization;
  }

  return normalizedToken;
};



// WEBPACK FOOTER //
// ./src/utils/authToken.js